import { createSelector } from '@ngrx/store';

import { getOrderErrorsMapped } from '../../onlineOrder/getOrderErrorsMapped';
import { getCartTotalQuantity } from '@shared/state/cart/selectors/getCartTotalQuantity';
import { isPaymentDisabledForOnlineOrderValidation } from '../isPaymentDisabledForOnlineOrderValidation';
import { isPaymentDisabledForPayments } from '@shared/state/payment/selectors';
import { isPaymentDisabledForMemberWithVendorServiceProviders } from '@shared/state/members/selectors';
import { isZeroPaymentsDisabled } from '../isZeroPaymentsDisabled';
import { hasExceededProductsLimit } from '../../restrictions/hasExceededProductsLimit';

export const isVendorServicePaymentDisabled = createSelector(
    getOrderErrorsMapped(),
    getCartTotalQuantity,
    isPaymentDisabledForOnlineOrderValidation,
    isPaymentDisabledForMemberWithVendorServiceProviders,
    isPaymentDisabledForPayments,
    isZeroPaymentsDisabled,
    hasExceededProductsLimit,
    (errors, cartTotalQuantity, orderPaymentDisabled, memberPaymentDisabled, paymentDisabledForPayments, zeroPaymentDisabled, exceededLimit) =>
        !cartTotalQuantity ||
        paymentDisabledForPayments ||
        orderPaymentDisabled ||
        exceededLimit ||
        (memberPaymentDisabled && (zeroPaymentDisabled ?? memberPaymentDisabled)) ||
        Boolean(errors),
);
